import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/deploy/twin3/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/deploy/twin3/components/projects/ProjectCatalogue.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectNavigation"] */ "/home/deploy/twin3/components/projects/ProjectNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/deploy/twin3/components/projects/ProjectsClient.tsx");
;
import(/* webpackMode: "eager" */ "/home/deploy/twin3/node_modules/@prismicio/next/dist/PrismicNextImage.cjs");
;
import(/* webpackMode: "eager" */ "/home/deploy/twin3/node_modules/@prismicio/next/dist/PrismicPreviewClient.cjs");
;
import(/* webpackMode: "eager" */ "/home/deploy/twin3/node_modules/@prismicio/next/dist/SliceSimulator.cjs");
;
import(/* webpackMode: "eager" */ "/home/deploy/twin3/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/deploy/twin3/node_modules/next/dist/client/script.js");
